import React from "react"
import Positions from "../../../components/position/Positions"
import * as userActions from "../../../actions/UserActions"
import { IUserDocument, ELoggedInUserType } from "../../../models"
interface IProps {
    user: IUserDocument
    readonly: boolean
    loggedInUserType: ELoggedInUserType
}

const UserDetailsPositions: React.SFC<IProps> = (props: IProps) => {
    return (
        <Positions
            isEmployee
            readonly={props.readonly}
            hideBill={props.loggedInUserType === ELoggedInUserType.Employee}
            positions={props.user.Positions}
            usablePositions={[]}
            payrollPayGroupData={{
                PayrollHierarchyItemId: props.user.PayrollHierarchyItemId,
                PayrollPayGroupId: props.user.PayrollPayGroupId
            }}
            handleAdd={(position, cb) =>
                userActions.addPosition(props.user.Id, position, cb)
            }
            handleUpdate={(position, cb) =>
                userActions.updatePosition(props.user.Id, position, cb)
            }
            handleDelete={(positions, cb) =>
                userActions.removePositions(props.user.Id, positions.map(item => item.Id), cb)
            }
        />
    )
}

export default UserDetailsPositions
